import { AMENITY_CATEGORIES } from './communitySiteUtils';

export const AMENITY_CATEGORY_META = {
  [AMENITY_CATEGORIES.CLUB_HOUSE]: { title: 'Club House', icon: 'home' },
  [AMENITY_CATEGORIES.OUTDOOR]: { title: 'Outdoor Amenities', icon: 'tree' },
  [AMENITY_CATEGORIES.UTILITY]: { title: 'Utility Areas', icon: 'wrench' },
  [AMENITY_CATEGORIES.PARKING_ACCESS]: { title: 'Parking & Access', icon: 'car' },
};

export const AMENITY_TEMPLATES = [
  { id: 'badminton', name: 'Badminton Court', category: AMENITY_CATEGORIES.CLUB_HOUSE },
  { id: 'table_tennis', name: 'Table Tennis', category: AMENITY_CATEGORIES.CLUB_HOUSE },
  { id: 'gym', name: 'Gym', category: AMENITY_CATEGORIES.CLUB_HOUSE },
  { id: 'yoga', name: 'Yoga Room', category: AMENITY_CATEGORIES.CLUB_HOUSE },
  { id: 'pool', name: 'Swimming Pool', category: AMENITY_CATEGORIES.CLUB_HOUSE },
  { id: 'indoor_games', name: 'Indoor Games', category: AMENITY_CATEGORIES.CLUB_HOUSE },
  { id: 'banquet', name: 'Banquet Hall', category: AMENITY_CATEGORIES.CLUB_HOUSE },
  { id: 'theater', name: 'Mini Theater', category: AMENITY_CATEGORIES.CLUB_HOUSE },
  { id: 'spa', name: 'Spa', category: AMENITY_CATEGORIES.CLUB_HOUSE },
  { id: 'coworking', name: 'Co-working Space', category: AMENITY_CATEGORIES.CLUB_HOUSE },
  { id: 'garden', name: 'Garden', category: AMENITY_CATEGORIES.OUTDOOR },
  { id: 'fountain', name: 'Fountain', category: AMENITY_CATEGORIES.OUTDOOR },
  { id: 'walking_path', name: 'Walking Path', category: AMENITY_CATEGORIES.OUTDOOR },
  { id: 'cycling_path', name: 'Cycling Path', category: AMENITY_CATEGORIES.OUTDOOR },
  { id: 'kids_play', name: 'Kids Play Area', category: AMENITY_CATEGORIES.OUTDOOR },
  { id: 'amphitheater', name: 'Amphitheater', category: AMENITY_CATEGORIES.OUTDOOR },
  { id: 'senior_area', name: 'Senior Citizen Area', category: AMENITY_CATEGORIES.OUTDOOR },
  { id: 'cricket_net', name: 'Cricket Net', category: AMENITY_CATEGORIES.OUTDOOR },
  { id: 'basketball', name: 'Basketball Court', category: AMENITY_CATEGORIES.OUTDOOR },
  { id: 'open_gym', name: 'Open Gym', category: AMENITY_CATEGORIES.OUTDOOR },
  { id: 'stp', name: 'STP', category: AMENITY_CATEGORIES.UTILITY },
  { id: 'transformer', name: 'Transformer Room', category: AMENITY_CATEGORIES.UTILITY },
  { id: 'dg', name: 'DG Room', category: AMENITY_CATEGORIES.UTILITY },
  { id: 'pump', name: 'Pump Room', category: AMENITY_CATEGORIES.UTILITY },
  { id: 'garbage', name: 'Garbage Room', category: AMENITY_CATEGORIES.UTILITY },
  { id: 'security_cabin', name: 'Security Cabin', category: AMENITY_CATEGORIES.UTILITY },
  { id: 'visitor_parking', name: 'Visitor Parking', category: AMENITY_CATEGORIES.PARKING_ACCESS },
  { id: 'ev_charging', name: 'EV Charging', category: AMENITY_CATEGORIES.PARKING_ACCESS },
  { id: 'entry_gate', name: 'Entry Gate', category: AMENITY_CATEGORIES.PARKING_ACCESS },
  { id: 'exit_gate', name: 'Exit Gate', category: AMENITY_CATEGORIES.PARKING_ACCESS },
  { id: 'loading_bay', name: 'Loading Bay', category: AMENITY_CATEGORIES.PARKING_ACCESS },
];

export const templatesForCategory = categoryId =>
  AMENITY_TEMPLATES.filter(t => t.category === categoryId);

export const AMENITY_CATEGORY_IDS = Object.values(AMENITY_CATEGORIES);
